import { fetchArticle } from '@elevio/kb-kit/lib/api/article';
import { useEffect, useState } from 'react';
import ArticleList from '../components/ArticleList';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HomeArticles from '../components/HomeArticles';
import { MainSection } from '../components/layouts/Main';
import PageLayout from '../components/layouts/Page';
import { fetchAgencyFlags } from '../requests/agency-flags';
import { AGENCY_ID, homeArticleIds } from '../utils/constants';
import { privateSubmissionUrl } from '../utils/privateSubmissionUrl';
const openPrivateSubmission = (path) => {
    const url = privateSubmissionUrl(path);
    if (!url) {
        return;
    }
    const newWindow = window.open(url, '_blank');
    if (newWindow) {
        newWindow.opener = null;
    }
};
export const getHeader = () => {
    return (<Header hideSearch>
      <div className="home-hero-section"/>
    </Header>);
};
const HomePage = () => {
    const [articles, setArticles] = useState([]);
    const [showViewAllRequests, setShowViewAllRequests] = useState(false);
    useEffect(() => {
        let cancelled = false;
        fetchAgencyFlags(AGENCY_ID).then((data) => {
            if (!cancelled) {
                setShowViewAllRequests(Boolean(data === null || data === void 0 ? void 0 : data.isPublicMapEnabled));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const responses = await Promise.all(homeArticleIds.map((id) => fetchArticle(id, '1')));
                setArticles(responses);
            }
            catch (error) {
                console.error('Error fetching articles:', error);
            }
        };
        fetchArticles();
    }, []);
    const handleSubmitRequest = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('create');
    };
    const handleViewMyRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('listing');
    };
    const handleViewAllRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('public-map');
    };
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <MainSection className="page-text-color">
        <div className="login-button-container">
          <section className="button-container button-container--three">
            <div className="button-wrapper">
              <button type="button" className="cta-request" onClick={handleSubmitRequest}>
                <img src={`${window.assetsLocation}/images/request.svg`} alt="" aria-hidden="true"/>
                Submit a Request
              </button>
            </div>
            <div className="button-wrapper">
              <button type="button" className="cta-request" onClick={handleViewMyRequests}>
                <img src={`${window.assetsLocation}/images/inbox.svg`} alt="" aria-hidden="true"/>
                View My Requests
              </button>
            </div>
            {showViewAllRequests ? (<div className="button-wrapper">
                <button type="button" className="cta-request" onClick={handleViewAllRequests}>
                  <img src={`${window.assetsLocation}/images/map.svg`} alt="" aria-hidden="true"/>
                  View All Requests
                </button>
              </div>) : null}
          </section>
        </div>
        <section className="article-container">
          <div className="view-requests-section">
            <HomeArticles articles={articles}/>
          </div>
          <div className="view-requests-section">
            <ArticleList />
          </div>
        </section>
      </MainSection>
    </PageLayout>);
};
export default HomePage;
